
import { computed, defineComponent, reactive, ref } from 'vue';

export default defineComponent({
	props: ['config', 'model', 'myKey', 'id'],
	setup(props) {
		const config: any = reactive(props.config);
		const model: any = reactive(props.model);
		const myKey: any = ref(props.myKey);
		let timer: number | undefined = undefined;
		const type = config.valueType;
		const myModel: any = computed({
			get() {
				return model[myKey.value];
			},
			set(value) {
				clearInterval(timer);
				timer = setTimeout(() => {
					if (type === 'string') {
						model[myKey.value] = String(value);
						return;
					}
					if (type === 'number') {
						model[myKey.value] = Number(value);
						return;
					}
					if (type === 'boolean') {
						model[myKey.value] = Boolean(Number(value));
					}
				}, 1000);
			},
		});

		return { myModel };
	},
});
